export default __webpack_public_path__ + "static/media/corporate-allur.d70a8ee1.jpg";